<template>
  <aside id="gnb" style="z-index: 10">
    <ul class="btn">
      <li v-for="(menu, index) in menuList" v-bind:key="index" :class="{'on': selectedTopMenuId === menu.mapSysNo}" >
        <a href="#" @click.prevent="clickTopMenu( menu.mapSysNo, menu.children )"> {{menu.mapSysNm }}</a>
      </li>
    </ul>
    <div class="cnt" v-show="isShowMenu" style="overflow:scroll;">
      <!-- 통계분류 Start.. -->
      <h2 class="depth01-title">통계분류</h2>
      <div v-for="(menu, index) in menuList" v-bind:key="index">
        <ul v-for="(subMenu, subIndex) in menu.children" v-bind:key="subIndex" class="depth01" :class="{'on': selectedTopMenuId === menu.mapSysNo}"  >
          <li :part-title="subMenu.mapSysNm">
            <button type="button" id="partTittleBtn" class="part-title-btn" @click.prevent="slideBtn($event)">{{subMenu.mapSysNm}}</button>
            <ul class="depth02-area">
              <li v-for="(statMenu, statMenuIndex) in subMenu.children" v-bind:key="statMenuIndex" :class="{'on': selectedStatMenuId === statMenu.mapSysNo}" >
                <button type="button" class="tab_btn" @click.prevent="clickStatMenu( statMenu )">{{ statMenu.mapSysNm }} </button>
                <div class="depth02">

                  <!-- 지도옵션 Start.. -->
                  <h3 class="depth02-title">지도옵션</h3>
                  <ul>
                    <li v-if="statMenu.sidoYn === 'Y'">
                      <div class="checkbox">
                        <input type="checkbox" ref="mapOpt_sidoYn" id="mapOptSidoYn" value="sidoYn" v-model="selectedMapOptionList" @change="changeMapOption('sidoYn', $event)"/>
                        <label for="mapOptSidoYn">시도</label>
                      </div>
                    </li>
                    <li v-if="statMenu.sigunguYn === 'Y'">
                      <div class="checkbox">
                        <input type="checkbox" ref="mapOpt_sigunguYn" id="mapOptSigunguYn" value="sigunguYn" v-model="selectedMapOptionList" @change="changeMapOption('sigunguYn', $event)"/>
                        <label for="mapOptSigunguYn">시군구</label>
                      </div>
                    </li>
                    <li v-if="statMenu.positionYn === 'Y'">
                      <div class="checkbox">
                        <input type="checkbox" ref="mapOpt_positionYn" id="mapOptPositionYn" value="positionYn" v-model="selectedMapOptionList" @change="changeMapOption('positionYn', $event)"/>
                        <label for="mapOptPositionYn">위치</label>
                      </div>
                    </li>
                    <li v-if="statMenu.compareYn === 'Y'">
                      <div class="checkbox">
                        <input type="checkbox" ref="mapOpt_compareYn" id="mapOptCompareYn" value="compareYn" v-model="selectedMapOptionList" @change="changeMapOption('compareYn', $event)"/>
                        <label for="mapOptCompareYn">비교</label>
                      </div>
                    </li>
                  </ul>
                  <!-- 지도옵션 항목 End.. -->

                  <!-- 통계표 항목 Start.. -->
                  <h3 class="depth02-title">항목목록</h3>
                  <ul>
                    <li v-for="(statItem, statItemIndex) in statItemList" v-bind:key="statItemIndex" >
                      <div class="checkbox">
                        <input type='checkbox' v-bind:id="statItem.mapItmNo" v-bind:value="statItem" v-model="selectedStatItemList" @change="selectStatMenu(statItem, $event)">
                        <label v-bind:for="statItem.mapItmNo">{{ statItem.mapItmOutNm }}</label>
                      </div>
                    </li>
                  </ul>
                  <!-- 통계표 항목 End.. -->

                  <!-- 통계표 항목 Start.. -->
                  <h3 class="depth02-title">해당 연도</h3>
                  <ul>
                    <li v-for="(statYearItem, statItemYearIndex) in statItemYearList" v-bind:key="statItemYearIndex" >
                      <div class="checkbox">
                        <input type='checkbox' v-bind:id="statYearItem.year" v-bind:value="statYearItem.year" v-model="selectedStatItemYearList" @change="selectStatYear()">
                        <label v-bind:for="statYearItem.year">{{ statYearItem.year }}년</label>
                      </div>
                    </li>
                  </ul>
                  <!-- 통계표 항목 End.. -->

                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- 통계분류 End.. -->
    </div>
    <button type="butotn" id="menuToggle" class="menu-toggle" title="통계분류 숨김 버튼"
            @click.prevent="clickMenuToggle()">통계분류 숨김 버튼</button>
  </aside>
</template>

<script>
import commonUI from '@/mixin/commonUI'
import menuApi from '@/api/web/MenuApi'
import { eventBus } from '@/event-bus'
import { mapActions, mapGetters } from 'vuex'

const statItemStore = 'statItemStore'

export default {
  name: 'Menu',
  mixins: [commonUI],
  data () {
    return {
      menuList: null,
      statItemList: [],
      statItemYearList: [],
      selectedTopMenuId: '',
      selectedStatMenuId: '',
      selectedStatMenu: null,
      selectedStatItemList: [],
      selectedStatItemYearList: [],
      isShowStatMenuLocation: true,
      isShowMenu: true,
      selectedMapOptionList: [this.$mapType.SI_DO]
    }
  },
  computed: {
    ...mapGetters(statItemStore, {
      statItemMaxCount: 'statItemMaxCount',
      findStatItem: 'findStatItem',
      selectedStatItems: 'selectedStatItems'
    })
  },
  created () {
    this.searchMenu()

    eventBus.$on('sendCloseStatItem', (closeStatItm) => {
      for (let idx = 0; idx < this.selectedStatItemList.length; idx++) {
        const statItem = this.selectedStatItemList[idx]
        if (statItem.mapItmNo === closeStatItm.mapItmNo) {
          this.selectedStatItemList.splice(idx, 1)

          this.selectStatMenu(statItem)
        }
      }
    })
  },

  mounted () {
    // this.clickMenuToggle()
  },

  methods: {
    ...mapActions(statItemStore, {
      addStatItem: 'addStatItem',
      removeStatItem: 'removeStatItem',
      setStatItemYearList: 'setStatItemYearList',
      setMapOptions: 'setMapOptions',
      removeAllStatItem: 'removeAllStatItem'
    }),

    // 메뉴 조회
    async searchMenu () {
      const searchMenuData = await menuApi.searchMenu()
      this.menuList = searchMenuData

      if (this.menuList.length > 0) {
        if (this.$route.params.topMenu) {
          this.selectedTopMenuId = this.$route.params.topMenu
        } else {
          this.selectedTopMenuId = this.menuList[1].mapSysNo
        }
      }
    },

    // 통계분류에 해당하는 항목 조회
    async searchStatItem (mapSysNo) {
      const searchStatItemData = await menuApi.searchStatItemList(mapSysNo)
      this.statItemList = searchStatItemData
    },

    // 통계분류 항목에 해당 연도 목록 조회
    async searchStatItemYear (mapSysNo) {
      const searchStatItemYearData = await menuApi.searchStatItemYear(mapSysNo)

      this.statItemYearList = searchStatItemYearData
      this.selectedStatItemYearList = []

      const selectedStatItems = this.selectedStatItems
      for (const selectedStatItem of selectedStatItems) {
        if (this.selectedStatMenuId === selectedStatItem.mapSysNo) {
          this.selectedStatItemYearList = selectedStatItem.years
        }
      }
    },

    // 메뉴 클릭 이벤트
    clickTopMenu (mapSysNo, menuChildren) {

      if (menuChildren && menuChildren.length > 0) {
        this.isShowMenu = true
        this.selectedTopMenuId = mapSysNo
        this.selectedStatMenuId = ''
        this.selectedStatMenu = null

        this.showMenuToggleLocation(true)
      } else {
        this.removeAllStatItem()
        this.$router.push({
          name: 'board',
        })
      }
    },

    // 통계분류 메뉴 클릭 이벤트
    clickStatMenu (statMenu) {
      this.selectedStatMenu = statMenu
      this.selectedStatMenuId = statMenu.mapSysNo

      if (!this.selectedStatMenu.srcNo) {
        this.selectedStatMenu.srcCd = ''
        this.selectedStatMenu.srcNm = ''
      }

      this.showMenuToggleLocation(false)
      this.searchStatItem(this.selectedStatMenu.mapSysNo)
      this.searchStatItemYear(this.selectedStatMenu.mapSysNo)
    },

    // 지도항목 변경 이벤트
    changeMapOption (mapOptRef, $event) {
      if (!$event.target.checked && this.selectedMapOptionList.length === 0) {
        $event.target.checked = true
        this.selectedMapOptionList.push(mapOptRef)
      } else {
        if (this.selectedStatItemList.length > 0 || this.selectedStatItemYearList.length > 0) {
          this.confirmWarning('확인', '지도 옵션 변경 시 선택 된 내용은 모두 초기화 됩니다.'
            , () => {
              this.selectedMapOptionList = []

              if ($event.target.checked) {
                this.selectedMapOptionList.push(mapOptRef)
              }
              this.setMapOptions(this.selectedMapOptionList)
              this.removeAllStatItem()
              this.selectedStatItemList = []
              this.selectedStatItemYearList = []
            }, () => {
              const refId = 'mapOpt_' + this.selectedMapOptionList[0]

              $event.target.checked = false
              this.$refs[refId].checked = true

              const removeIdx = this.selectedMapOptionList.indexOf(mapOptRef)
              if (removeIdx > -1) {
                this.selectedMapOptionList.splice(removeIdx, 1)
              }
            }
          )
        } else {
          this.selectedMapOptionList = []

          if ($event.target.checked) {
            this.selectedMapOptionList.push(mapOptRef)
          }

          this.setMapOptions(this.selectedMapOptionList)
        }
      }
    },

    // 항목목록 메뉴 선택
    selectStatMenu (statItem, $event) {
      if (this.selectedMapOptionList.length > 0) {
        const selectedMapOption = this.selectedMapOptionList[0]
        const selectedMapOptionName = this.getMapOptionName(selectedMapOption)
        const mapOptionType = this.selectedStatMenu[selectedMapOption]

        if (mapOptionType == null || mapOptionType == undefined) {
          this.selectedStatItemList.splice(this.selectedStatItemList.length - 1, 1)
          $event.target.checked = false
          alert(statItem.mapItmNm + ' 항목은 "'+ selectedMapOptionName +'" 옵션을 지원하지 않습니다.')
          return
        } else {
          if (mapOptionType !== 'Y') {
            this.selectedStatItemList.splice(this.selectedStatItemList.length - 1, 1)
            $event.target.checked = false
            alert(statItem.mapItmNm + ' 항목은 "'+ selectedMapOptionName +'" 옵션을 지원하지 않습니다.')
            return
          }
        }
      } else {
        return
      }


      if (this.selectedStatItemList.length > this.statItemMaxCount) {
        this.selectedStatItemList.splice(this.selectedStatItemList.length - 1, 1)
        $event.target.checked = false
        alert('최대 3개까지만 선택이 가능 합니다.')
      } else {
        const findItem = this.findStatItem(statItem.mapItmNo)
        if (findItem) {
          this.removeStatItem({ info: statItem })
        } else {
          if (this.selectedStatItemList.length <= this.statItemMaxCount) {
            this.addStatItem({
              mapSysNo: this.selectedStatMenuId,
              mapSysNm: this.selectedStatMenu.mapSysNm,
              srcCd: this.selectedStatMenu.srcCd,
              srcNo: this.selectedStatMenu.srcNo,
              info: statItem,
              years: this.selectedStatItemYearList
            })
          }
        }
        this.searchStatItemYear(this.selectedStatMenuId)
      }
    },

    // 해당연도 선택
    selectStatYear () {
      this.setStatItemYearList({
        mapSysNo: this.selectedStatMenuId,
        yearList: this.selectedStatItemYearList
      })
    },

    // 메뉴바 토글 이벤트 설정
    showMenuToggleLocation (isShowStatMenuLocation) {
      this.isShowStatMenuLocation = isShowStatMenuLocation

      document.getElementById('menuToggle').classList.remove('off')

      if (this.isShowStatMenuLocation) {
        document.getElementById('menuToggle').style.left = '431px'
      } else {
        document.getElementById('menuToggle').style.left = '710px'
      }
    },

    clickMenuToggle () {
      this.isShowMenu = !this.isShowMenu

      if (this.isShowMenu) {
        document.getElementById('menuToggle').classList.remove('off')
        this.showMenuToggleLocation(this.isShowStatMenuLocation)
      } else {
        document.getElementById('menuToggle').classList.add('off')
        document.getElementById('menuToggle').style.left = '110px'
      }
    },
    slideBtn (event) {
      if (!event.target.classList.contains('active')) {
        event.target.classList.add('active')
      } else {
        event.target.classList.remove('active')
      }
    },

    getMapOptionName(mapOptionType) {
      if (this.$mapType.SI_DO == mapOptionType) {
        return '시도'
      } else if (this.$mapType.COMPARE == mapOptionType) {
        return '비교'
      } else if (this.$mapType.SI_GUN_GU == mapOptionType) {
        return '시군구'
      } else if (this.$mapType.POSITION == mapOptionType) {
        return '위치'
      }
      return ''
    }
  }
}
</script>

<style scoped>

</style>
